import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import ContentCard from "@/components/ContentCard";

export default function ContentRow({ title, subtitle, items }) {
  const ref = useRef(null);
  if (!items?.length) return null;

  const scroll = (dir) => {
    ref.current?.scrollBy({ left: dir * ref.current.clientWidth * 0.8, behavior: "smooth" });
  };

  return (
    <section className="relative group/row py-4">
      <div className="flex items-end justify-between px-4 sm:px-6 lg:px-10 mb-3">
        <div>
          <h2 className="font-display font-bold text-xl sm:text-2xl">{title}</h2>
          {subtitle && <p className="text-sm text-white/50 mt-0.5">{subtitle}</p>}
        </div>
        <div className="hidden md:flex gap-2">
          <button onClick={() => scroll(-1)} className="w-9 h-9 rounded-full bg-white/5 border border-white/10 hover:bg-white/15 flex items-center justify-center transition-colors" aria-label="scroll left">
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button onClick={() => scroll(1)} className="w-9 h-9 rounded-full bg-white/5 border border-white/10 hover:bg-white/15 flex items-center justify-center transition-colors" aria-label="scroll right">
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>
      <div ref={ref} className="flex gap-4 overflow-x-auto no-scrollbar px-4 sm:px-6 lg:px-10 pb-2 snap-x">
        {items.map((it, i) => (
          <div key={it.id} className="snap-start shrink-0 w-[150px] sm:w-[180px]">
            <ContentCard item={it} index={i} />
          </div>
        ))}
      </div>
    </section>
  );
}
